import { createSvgIcon } from "@mui/material";

export const CancellationPolicyIcon = createSvgIcon(
  <path
    d="M7.00065 13.6666C10.6827 13.6666 13.6673 10.6819 13.6673 6.99992C13.6673 3.31792 10.6827 0.333252 7.00065 0.333252C3.31865 0.333252 0.333984 3.31792 0.333984 6.99992C0.333984 10.6819 3.31865 13.6666 7.00065 13.6666ZM3.72998 11.2133L11.214 3.72925C12.0117 4.75537 12.4072 6.03745 12.3263 7.33462C12.2454 8.6318 11.6936 9.85479 10.7745 10.7738C9.85552 11.6928 8.63253 12.2446 7.33536 12.3256C6.03818 12.4065 4.7561 12.0109 3.72998 11.2133ZM2.78732 10.2706C1.98963 9.24447 1.59409 7.96239 1.67501 6.66521C1.75593 5.36804 2.30773 4.14505 3.22676 3.22603C4.14578 2.307 5.36877 1.75519 6.66595 1.67428C7.96312 1.59336 9.2452 1.9889 10.2713 2.78659L2.78732 10.2706Z"
    fill="#DF473F"
  />,
  "CancellationPolicy"
);
